import { bindRequestLogic } from './utils'
import PortalUserType from '../actionTypes/portalUser'
import { portalUserAPI } from '../api'

export const getPortalUserList = bindRequestLogic({
  clientFunc: portalUserAPI.getPortalUserList,
  type: PortalUserType.GET_PORTAL_USER_LIST_REQUEST,
  successType: PortalUserType.GET_PORTAL_USER_LIST_SUCCESS,
  failType: PortalUserType.GET_PORTAL_USER_LIST_FAILED,
  isQueryParam: true
})

export const getPortalUserDetail = bindRequestLogic({
  clientFunc: portalUserAPI.getPortalUserDetail,
  type: PortalUserType.GET_PORTAL_USER_DETAIL_REQUEST,
  successType: PortalUserType.GET_PORTAL_USER_DETAIL_SUCCESS,
  failType: PortalUserType.GET_PORTAL_USER_DETAIL_FAILED
})

export const addPortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.addPortalUser,
  type: PortalUserType.ADD_PORTAL_USER_REQUEST,
  successType: PortalUserType.ADD_PORTAL_USER_SUCCESS,
  failType: PortalUserType.ADD_PORTAL_USER_FAILED
})

export const updatePortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.updatePortalUser,
  type: PortalUserType.UPDATE_PORTAL_USER_REQUEST,
  successType: PortalUserType.UPDATE_PORTAL_USER_SUCCESS,
  failType: PortalUserType.UPDATE_PORTAL_USER_FAILED
})

export const upsertGDPRPortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.upsertGDPRPortalUser,
  type: PortalUserType.UPSERT_GDPR_PORTAL_USER_REQUEST,
  successType: PortalUserType.UPSERT_GDPR_PORTAL_USER_SUCCESS,
  failType: PortalUserType.UPSERT_GDPR_PORTAL_USER_FAILED
})

export const getGDPRPortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.getGDPRPortalUser,
  type: PortalUserType.GET_GDPR_PORTAL_USER_REQUEST,
  successType: PortalUserType.GET_GDPR_PORTAL_USER_SUCCESS,
  failType: PortalUserType.GET_GDPR_PORTAL_USER_FAILED
})

export const getVehiclePortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.getVehiclePortalUser,
  type: PortalUserType.GET_VEHICLE_PORTAL_USER_REQUEST,
  successType: PortalUserType.GET_VEHICLE_PORTAL_USER_SUCCESS,
  failType: PortalUserType.GET_VEHICLE_PORTAL_USER_FAILED
})

export const getCompaniesPortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.getCompaniesPortalUser,
  type: PortalUserType.GET_COMPANIES_PORTAL_USER_REQUEST,
  successType: PortalUserType.GET_COMPANIES_PORTAL_USER_SUCCESS,
  failType: PortalUserType.GET_COMPANIES_PORTAL_USER_FAILED
})

export const getPortalUserPortalRole = bindRequestLogic({
  clientFunc: portalUserAPI.getPortalUserPortalRole,
  type: PortalUserType.GET_PORTAL_USER_PORTAL_ROLE_REQUEST,
  successType: PortalUserType.GET_PORTAL_USER_PORTAL_ROLE_SUCCESS,
  failType: PortalUserType.GET_PORTAL_USER_PORTAL_ROLE_FAILED
})

export const getRolePortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.getRolePortalUser,
  type: PortalUserType.GET_ROLE_PORTAL_USER_REQUEST,
  successType: PortalUserType.GET_ROLE_PORTAL_USER_SUCCESS,
  failType: PortalUserType.GET_ROLE_PORTAL_USER_FAILED
})

export const updateRolePortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.updateRolePortalUser,
  type: PortalUserType.UPDATE_ROLE_PORTAL_USER_REQUEST,
  successType: PortalUserType.UPDATE_ROLE_PORTAL_USER_SUCCESS,
  failType: PortalUserType.UPDATE_ROLE_PORTAL_USER_FAILED
})

const getDirectVehiclesPortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.getDirectVehiclesPortalUser,
  type: PortalUserType.GET_DIRECT_VEHICLES_PORTAL_USER_REQUEST,
  successType: PortalUserType.GET_DIRECT_VEHICLES_PORTAL_USER_SUCCESS,
  failType: PortalUserType.GET_DIRECT_VEHICLES_PORTAL_USER_FAILED,
  isQueryParam: true
})

const cancelDirectVehiclePortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.cancelDirectVehiclePortalUser,
  type: PortalUserType.CANCEL_DIRECT_VEHICLE_PORTAL_USER_REQUEST,
  successType: PortalUserType.CANCEL_DIRECT_VEHICLE_PORTAL_USER_SUCCESS,
  failType: PortalUserType.CANCEL_DIRECT_VEHICLE_PORTAL_USER_FAILED
})

const getCommSystemLogsPortalUser = bindRequestLogic({
  clientFunc: portalUserAPI.getCommSystemLogsPortalUser,
  type: PortalUserType.GET_COMM_SYSTEM_LOGS_PORTAL_USER_REQUEST,
  successType: PortalUserType.GET_COMM_SYSTEM_LOGS_PORTAL_USER_SUCCESS,
  failType: PortalUserType.GET_COMM_SYSTEM_LOGS_PORTAL_USER_FAILED
})

export default [
  getPortalUserList,
  getPortalUserDetail,
  addPortalUser,
  updatePortalUser,
  upsertGDPRPortalUser,
  getGDPRPortalUser,
  getVehiclePortalUser,
  getCompaniesPortalUser,
  getPortalUserPortalRole,
  getRolePortalUser,
  updateRolePortalUser,
  getDirectVehiclesPortalUser,
  cancelDirectVehiclePortalUser,
  getCommSystemLogsPortalUser
]
